import React from "react";

import {Link} from "../../../../../../../../../router";

import MerchantNavigationItemInner from "../MerchantNavigationItemInner";

export default ({id, className, href, onClick, ...props}) => (
  <Link className={className} href={href} data-testid={id} onClick={onClick}>
    <MerchantNavigationItemInner {...props} />
  </Link>
);
